(function () {
  'use strict';

  Vue.component('modal', {
    template: '#modal-template',
  });

  var genres =
    $('html').data('lang') === 'zh'
      ? ['劇情長片', '電視劇', '短片', '紀錄片', '動畫片', '其他']
      : [
          'Feature films',
          'Tv dramas',
          'Short films',
          'Documentary',
          'Animation',
          'Other',
        ];

  var tags =
    $('html').data('lang') === 'zh'
      ? ['現場錄音', '後期製作']
      : ['Location record', 'Post product'];

  var app = new Vue({
    el: '#app',
    data: {
      works: [],
      selected: {},
      showModal: false,
      limit: 16,
      counter: 16,
      sort: 'all',
      tags: tags,
      genres: genres,
      observer: null,
      currentWork: null,
    },
    created: function () {
      var _that = this;
      this.works = works
        .map(function (work) {
          return {
            isShow: work.isShow,
            img: work.img,
            genre: _that.genres[work.genre],
            title: work.title,
            title_en: work.title_en,
            year: work.year,
            crews: work.crews,
            tag: work.tag
              ? work.tag.map(function (tag) {
                  return _that.tags[tag];
                })
              : [],
          };
        })
        .filter(function (work) {
          return work.isShow;
        });
      this.totalLength = this.works.length;
    },
    mounted: function () {
      this.observer = new IntersectionObserver(this.observeElementFn, {
        threshold: 1.0,
      });
      this.observer.observe(this.$refs.ob);
    },
    methods: {
      setIndex: function (index, work) {
        this.currentWork = index;
        this.selected = work;
        this.showModal = true;
      },
      observeElementFn: function (entries) {
        if (entries[0].isIntersecting) {
          var _that = this;
          setTimeout(function () {
            _that.counter += _that.limit;
          }, 1000);
        }
      },
      sortBy: function (type) {
        this.counter = 16;
        this.sort = type;
        this.currentWork = null;
      },
    },
    computed: {
      isEnd: function () {
        return this.counter >= this.workLists.length;
      },
      workLists: function () {
        var _that = this;
        if (this.sort === 'all') {
          return this.works;
        }
        let filteredWorks = this.works.filter(function (work) {
          return work.genre === _that.sort;
        });

        let returnLists = filteredWorks;
        return returnLists;
      },
    },
  });
})();
